<template>
  <div>
    <el-table border :data="data" style="width: 100%" size="mini">
      <el-table-column prop="BusiName" label="领用人" min-width="120px" />
      <el-table-column prop="SendTime" label="领用时间" min-width="120px">
        <template slot-scope="{row}">
          <span>{{$commonJs.toDatetimeString(row.SendTime)}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="UseDate" label="使用时间" min-width="120px">
        <template slot-scope="{row}">
          <span>{{$commonJs.toDatetimeString(row.UseTime)}}</span>
        </template>
      </el-table-column>
      <slot name="column"></slot>
    </el-table>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      api: require("@/api/sale/couponCustomer").default,
      data: [],
    };
  },
  computed: {},
  methods: {
    setData(CouponId) {
      console.log(CouponId,"couponId");
      this.api.list({ CouponId: CouponId }).then((res) => {
        
        this.data = res.Data;
      });
    },
    clear() {
      this.data = [];
    },
  },
};
</script>